import { render, staticRenderFns } from "./formBaseDocument.vue?vue&type=template&id=bcee638c&scoped=true&"
import script from "./formBaseDocument.vue?vue&type=script&lang=js&"
export * from "./formBaseDocument.vue?vue&type=script&lang=js&"
import style0 from "./formBaseDocument.vue?vue&type=style&index=0&id=bcee638c&lang=scss&scoped=true&"
import style1 from "./formBaseDocument.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcee638c",
  null
  
)

export default component.exports